import { Block } from 'baseui/block';
import { useStyletron } from "baseui";
import { graphql, useStaticQuery } from 'gatsby';
import PropTypes from 'prop-types';
import * as React from 'react';
import Footer from './footer';
import Header from './header';
import 'theme/layout.css';

const Layout = ({ children }) => {
  const [css] = useStyletron();
  const mainStyles = css({
    marginTop: "72px",
  });

  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);


  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <Block className={mainStyles}>
        <main>{children}</main>
      </Block>
      <Footer />
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
